import React from "react";
import { Link } from "react-router-dom";
import guLocale from "../locales/gu";

const CallUsForm = () => {
  const locale = guLocale.cms.callUs;
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">{locale.title}</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">{locale.home}</Link>
                  </li>
                  <li className="breadcrumb-item active">{locale.title}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="callout callout-primary">
                  <div className="call-us-container mb-2">
                    <i className="fas fa-phone-alt call-us-icon"></i>
                    <span className="call-us-text">{locale.callUsText}</span>
                  </div>
                  <div className="call-us-container">
                    <i className="fab fa-whatsapp btn btn-success rounded-circle"></i>
                    <span className="call-us-text pl-3">{locale.whatsAppUsText}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CallUsForm;
